export default __webpack_public_path__ + "static/media/image-24.84ecacb0.webp";